import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export function Container(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (location.pathname === '/container') {
      navigate('/container/sensor', { replace: true });
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const typeParam = searchParams.get('type');

    if (!typeParam && location.pathname !== '/container') {
      // setSearchParams({ type: '0' }, { replace: true });
    }
  }, [location.pathname, searchParams, setSearchParams]);

  return <Outlet />;
}
